import { render, staticRenderFns } from "./ResellerTable.vue?vue&type=template&id=084531b8&scoped=true"
import script from "./ResellerTable.vue?vue&type=script&lang=js"
export * from "./ResellerTable.vue?vue&type=script&lang=js"
import style0 from "./ResellerTable.vue?vue&type=style&index=0&id=084531b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084531b8",
  null
  
)

export default component.exports